module.exports = window["MaterialUI"].GridList;